    import {  VerticalLayout, VerticalPageLayout } from "./layout"
    import { useContext, useEffect, useState } from "react"
    import {BuyAccounts, BuyCards} from '../molecule/buyAccounts.js'
    import {ActivateFeatures} from '../molecule/activateFeatures.js'
    import {Receipt} from '../molecule/receipt.js'
    import { getAPI, postAPI } from "../api/api.js"
    import { set } from "date-fns"
    import { Spinner } from "../atoms/spinner.js"
import { StandardButton } from "../atoms/buttons.js"
import { UserContext } from "../App.js"
    export const BuyFeaturesComp = () => {
        const [accountsTotal, setAccountsTotal] = useState(0)
        const [cardsTotal, setCardsTotal] = useState(0)
        const [loading, setLoading] = useState(false)
        const [features, setFeatures] = useState({ "active_accounts": 5, "features": [{ name: "Feature 1", description: "Beschrijving van feature 1", price: 10, owned: false, checked: false }, { name: "Feature 2", description: "Beschrijving van feature 2", price: 15, owned: true, checked: true }, { name: "Feature 3", description: "Beschrijving van feature 3", price: 20, owned: false, checked: false }, { name: "Feature 4", description: "Beschrijving van feature 4", price: 25, owned: false, checked: false }] })
        const [newReceiptDetails, setReceiptDetails] = useState([])
        const userContext = useContext(UserContext)
        const isPublic  = userContext.account_type === 1
        const handleAccounts = (value) => {
            if (accountsTotal === 0 && value > 0 || accountsTotal > 0) {
                setAccountsTotal(accountsTotal + value)
            } else{
                setAccountsTotal(0)
            }
        }
        const handleCards = (value) => {
            if (cardsTotal === 0 && value > 0 || cardsTotal > 0) {
                setCardsTotal(cardsTotal + value)
            } else {
                setCardsTotal(0)
            }
        }
        useEffect(() => {
            loadFeatures()
        },[])
        const loadFeatures = async () =>{
            setLoading(true)
            const query = `api/orders/features`
            const newFeatures = await getAPI(query)
            console.log(newFeatures.data)
            setFeatures(newFeatures.data)
            setLoading(false)
        }
        const handleFeatures = (index) => {
            const copyFeatures = [...features.features]
            copyFeatures[index].checked = !copyFeatures[index].checked
            setFeatures({ ...features, features: copyFeatures })
            setReceiptDetails(receiptDetails(copyFeatures))
        }

        const receiptDetails = (features) => {
            const details = []
            features.forEach(feature => {
                if (feature.checked) {
                    details.push(feature)
                }
            });
            return details
        }
        const handleBuyCards = async () => {
            const query = `api/cards/generate-cards`
            const body = {
                quantity: cardsTotal
            }
            const buyCards = await postAPI(query, body)
            console.log(buyCards)
        }
        if(loading) return <VerticalPageLayout className={"center"}><Spinner /></VerticalPageLayout>
        return (
            <VerticalLayout>
                {!isPublic && <BuyAccounts
                    activeAccounts={features.active_accounts}
                    accountsTotal={accountsTotal}
                    handleAccounts={handleAccounts}
                />}
                {isPublic && <BuyCards
                    activeCards={features.active_cards}
                    cardsTotal={cardsTotal}
                    handleCards={handleCards}
                />}
                
                <ActivateFeatures features={features.features} activate={handleFeatures} />
                <Receipt details={newReceiptDetails} total_new={accountsTotal} total_old={features.active_accounts} />
            </VerticalLayout>
        )
    }






